import { useState } from 'react';
import { getToken } from '../auth/UserService';
import documentUploadApiUrl from '../api/documentUploadApiUrl';

export function useDownload() {
  const [downloading, setDownloading] = useState({});
  const [error, setError] = useState<any>(null);

  async function downloadFiles(referenceId: number, documentIds: string[]) {
    const token = getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const body = JSON.stringify({
      referenceId,
      documentIds,
    });
    setDownloading(true);
    try {
      await fetch(documentUploadApiUrl + '/document/download', {
        method: 'POST',
        body,
        mode: 'cors',
        headers,
      });
    } catch (e) {
      setError(e);
    } finally {
      setDownloading(false);
    }
  }
  async function downloadSingleFile(
    referenceId: number,
    documentId: string
  ): Promise<{ url: string } | undefined> {
    const token = getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    const body = JSON.stringify({
      referenceId,
      documentId,
    });
    setDownloading(true);
    try {
      const response = await fetch(
        documentUploadApiUrl + '/single-document/download',
        {
          method: 'POST',
          body,
          mode: 'cors',
          headers,
        }
      );
      return await response.json();
    } catch (e) {
      setError(e);
    } finally {
      setDownloading(false);
    }
  }
  return { downloadFiles, downloadSingleFile, downloading, error };
}
